import { PropertyTableProps } from './types';
import PropertyTable from './OriginalTable';

const CompetitorPropertyTable = ({ propertyList, onSort, shouldShowDetail = true, isGridView }: PropertyTableProps) => {
    return <PropertyTable propertyList={propertyList} onSort={onSort} isForCompetitor={true} shouldShowDetail={shouldShowDetail} isGridView={isGridView} />;
};

export default CompetitorPropertyTable;
